import { Anchor } from 'antd';
import { useMemo } from 'react';
import styled from 'styled-components';
import { CONTENT_PADDING } from '../../affix/AffixManagerStore.ts';
import { useAffixOffset } from '../../affix/useAffixOffset.ts';
import { useConfigurationCardEntries } from '../ConfigurationCardContext.tsx';
import { sortEntriesByDomOrder } from '../sortEntriesByDomOrder.ts';
import { buildEntryTree } from './buildEntryTree.ts';
import { mapTreeToAnchorItems } from './mapTreeToAnchorItems.ts';

const StickyAnchorWrapper = styled.div`
  position: sticky;
  top: calc(var(--header-height, 0px) + var(--content-padding, 24px));

  .ant-anchor-link-title {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .ant-anchor .ant-anchor-link {
    padding-left: 12px;
  }
  .ant-anchor .ant-anchor-link-active > .ant-anchor-link-title {
    font-weight: 600;
  }
  .ant-anchor .ant-anchor-link .ant-anchor-link {
    .ant-anchor-link-title {
      font-size: 13px;
    }
  }
`;

/**
 * Navigazione laterale (`Anchor`) auto-generata dalle card registrate nel
 * `ConfigurationCardGroup` non-dense. Sticky sotto l'header di pagina tramite
 * l'AffixManager. Ritorna `null` se non ci sono voci.
 */
export function ConfigurationCardAnchor() {
  const entries = useConfigurationCardEntries();
  const sortedEntries = useMemo(
    () => sortEntriesByDomOrder(entries),
    [entries],
  );
  const tree = useMemo(() => buildEntryTree(sortedEntries), [sortedEntries]);
  const headerHeight = useAffixOffset();

  if (tree.length === 0) return null;

  return (
    <StickyAnchorWrapper>
      <Anchor
        affix={false}
        targetOffset={headerHeight + CONTENT_PADDING}
        items={mapTreeToAnchorItems(tree)}
      />
    </StickyAnchorWrapper>
  );
}
